import React from "react";
import { MDBCol } from "mdbreact";

//Components
import Navbar from "../../components/Navbar_inicio";
import FooterPage from "../../components/Footer";

//CSS
import "./Inicio.css";

//Landing sections
import Start from "./sections/Start";
import HowUse from "./sections/HowUse";
import Ambiente from "./sections/Ambiente";
import Seguridad from "./sections/Seguridad";
import Recomendaciones from "./sections/Recomendaciones"

class InicioDrivers extends React.Component {
  render() {
    return (
      <div id="appp">
        <MDBCol style={{ padding: "0px" }}>
          <Navbar />
          <Start />
          <HowUse />
          <Ambiente />
          <Seguridad />
          <Recomendaciones />
          <FooterPage />
        </MDBCol>
      </div>
    );
  }
}

export default InicioDrivers;
